

































import { Component, Mixins, Ref } from "vue-property-decorator";
import SettingsMixin from "@/mixins/http/SettingsMixin";
import UploadProgress from "@/components/Settings/MediumAudienceUploadProgress.vue";
import { FileUpload } from "@/models";

@Component({ components: { UploadProgress } })
export default class AudienceImport extends Mixins(SettingsMixin) {
  @Ref() readonly uploadFile!: HTMLInputElement;
  fileUpload: FileUpload | null = null;

  get databaseName() {
    return this.document ? this.document.name : "";
  }

  async onUpload() {
    if (this.document) {
      this.loading = true;
      const formData = new FormData();
      formData.append("document", this.document);
      formData.append("kind", "media");
      this.fileUpload = await this.uploadAudienceDatabase(formData);
      this.loading = false;
    } else {
      this.browse();
    }
  }

  get buttonLabel() {
    if (this.databaseName === "") {
      return "Scegli file";
    }
    return "Carica file";
  }

  browse() {
    this.uploadFile.click();
  }

  onDocument(e: any) {
    if (e.target && e.target.files) {
      this.document = e.target.files[0];
    }
  }

  private document: File | null = null;
  private loading = false;
}
